var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "mask-side-section-container",
    { attrs: { title: _vm.$tc("DuctEntry", 1) } },
    [
      _c(
        "v-flex",
        {
          staticClass: "tab-content px-0 py-1 scroll-fire-fox",
          staticStyle: { height: "100%", overflow: "auto" },
          attrs: { shrink: "" }
        },
        [
          _c("input-field", {
            attrs: {
              value: _vm.ductEntry.mde_label,
              label: "Label",
              "input-type": "text",
              size: "large",
              "field-disabled": _vm.disabled
            },
            on: {
              input: function($event) {
                return _vm.updateDuctEntry("mde_label", $event)
              }
            }
          }),
          _vm._v(" "),
          _c("input-field", {
            attrs: {
              value: _vm.ductEntry.mde_destination_specific_manhole_uuid,
              label: "Destination Manhole",
              inputType: "text",
              size: "large",
              "field-disabled": _vm.disabled
            },
            on: {
              input: function($event) {
                return _vm.updateDuctEntry(
                  "mde_destination_specific_manhole_uuid",
                  $event
                )
              }
            }
          }),
          _vm._v(" "),
          _c(
            "input-field",
            {
              attrs: {
                value: _vm.ductEntry.mde_destination_specific_mask,
                label: "Destination Mask",
                inputType: "other",
                size: "large",
                "field-disabled": _vm.disabled
              }
            },
            [
              _c(
                "div",
                [
                  _c("treeselect", {
                    staticClass: "form-input-select",
                    attrs: {
                      value: _vm.ductEntry.mde_destination_specific_mask,
                      options: _vm.maskOptions,
                      disableFuzzyMatching: ""
                    },
                    on: {
                      input: function($event) {
                        return _vm.updateDuctEntry(
                          "mde_destination_specific_mask",
                          $event
                        )
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("input-field", {
            attrs: {
              value: _vm.ductEntry.mde_state,
              label: "State",
              "input-type": "select",
              size: "large",
              "select-options": "list_duct_state",
              "field-disabled": _vm.disabled
            },
            on: {
              input: function($event) {
                return _vm.updateDuctEntry("mde_state", $event)
              }
            }
          }),
          _vm._v(" "),
          _vm.ductEntry.mde_state === "1"
            ? _c("input-field", {
                attrs: {
                  value: _vm.ductEntry.mde_total_reservation,
                  label: "",
                  "input-type": "checkbox",
                  checkboxOptions: _vm.totalReservationOption,
                  size: "large",
                  "field-disabled": _vm.disabled
                },
                on: {
                  change: function($event) {
                    return _vm.updateDuctEntry("mde_total_reservation", $event)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.ductEntry.mde_state !== "1"
            ? _c("input-field", {
                attrs: {
                  value: _vm.ductEntry.mde_occupancy_rate,
                  label: "Occupancy Rate (%)",
                  inputType: "select",
                  selectOptions: "list_duct_occupation_rates",
                  size: "large",
                  "field-disabled": _vm.disabled
                },
                on: {
                  input: function($event) {
                    return _vm.updateDuctEntry("mde_occupancy_rate", $event)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("duct-entry-form-cable-selection", {
            attrs: {
              cables: _vm.ductEntry.duct_entry_cables,
              disabled: _vm.disabled
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-456b0d86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-456b0d86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Masks/Duct/DuctEntryForm.vue
// module id = null
// module chunks = 